import { useDispatch, useSelector } from "../../../hooks";
import { setCurrentRating } from "../../../redux/ratings";
import { RatingType } from "../../../redux/ratings/get-ratings.handler";
import expIcon from './icons/exp.jpg';
import rareDrawIcon from './icons/rare-draw.jpg';
import epicDrawIcon from './icons/epic-draw.jpg';
import legendaryDrawIcon from './icons/legendary-draw.jpg';
import challenge1Icon from './icons/challenge-1.png';
import styles from './RatingsPanel.module.scss';

export const RatingsPanel = () => {
    const ratingsLib = useSelector(store => store.assets.ratings);
    const ratingState = useSelector(store => store.rating);

    const dispatch = useDispatch();

    const handler = (type: RatingType) => {
        dispatch(setCurrentRating(type));
    }

    const getIcon = (type: RatingType) => {
        switch (type) {
            case RatingType.Experience: return expIcon;
            case RatingType.RareDrawLuck: return rareDrawIcon;
            case RatingType.EpicDrawLuck: return epicDrawIcon;
            case RatingType.LegendaryDrawLuck: return legendaryDrawIcon;
            case RatingType.SubscriptionRewardChallenge: return challenge1Icon;
        }
    }

    return (
        <div className={ styles.content }>
            {
                ratingsLib
                    .map(item => {
                        return (
                            <div
                                className={ `${styles.icon} ${ item.type === ratingState.current ? styles.active : ''}` }
                                onClick={ () => handler(item.type) }
                            >
                                <img src={ getIcon(item.type) } alt={item.type.toString()} />
                            </div>
                        )
                })
            }
        </div>
    );
}